import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { Input } from '@/components/ui/input';
    import { Search } from 'lucide-vue-next';
    import { useVModel } from '@vueuse/core';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    defaultValue: {},
    modelValue: {},
    class: {},
    placeholder: {},
    type: { default: 'text' },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const value = computed({
        get: () => props.modelValue,
        set: (newValue: string | number) => {
            emits('update:modelValue', newValue);
        },
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Input), {
      class: _normalizeClass(_unref(cn)('w-full pl-7.5', props.class)),
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      placeholder: props.placeholder,
      type: props.type,
      disabled: props.disabled
    }, null, 8, ["class", "modelValue", "placeholder", "type", "disabled"]),
    _createVNode(_unref(Search), { class: "text-faded-foreground pointer-events-none absolute top-1/2 left-2 size-3.5 -translate-y-1/2" })
  ]))
}
}

})